<template>
    
    <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.registration" class="uk-section uk-flex uk-position-z-index-negative">        
    <div class="uk-margin-center uk-container uk-position-cente  uk-margin-large-top uk-align-center">
        <h2>{{ this.$store.getters.GetText.registration.title[this.$store.getters.Lang]}}</h2>
        <span>{{ this.$store.getters.GetText.registration.subtitle[this.$store.getters.Lang]}}</span>
    <div class="uk-child-width-expand@s uk-text-center " uk-grid>
        <!-- First -->
        <div class="uk-width-1-2@m">
        <div class="uk-margin ">
            <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.registration.name[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand ">
                <span class="uk-form-icon " uk-icon="icon: user"></span>
                <input v-model="name" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="name">
                </div>
            </div>
        <div class="uk-margin  ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.mail[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: mail"></span>
                <input v-model="email" v-bind:class="{'uk-form-danger': !email_verify }" v-on:input="checkEmail" class="uk-input  uk-text-center" type="email" aria-label="Not clickable icon" placeholder="" autocomplete="email">
            </div>
            </div>
            
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.pass[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: lock"></span>
                <input v-model="password" :title="password_title[this.$store.getters.Lang]" class="uk-input  uk-text-center" type="password" aria-label="Not clickable icon" placeholder="" autocomplete="new-password" minlength="8">
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.confirm[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: lock"></span>
                <input v-model="confirm"  :title="password_title[this.$store.getters.Lang]" class="uk-input  uk-text-center" type="password" aria-label="Not clickable icon" placeholder="" minlength="8" autocomplete="new-password">
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.work[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: users"></span>
            <input v-model="work" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="organization" name="work">
        </div>
        </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.phone[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: phone"></span>
            <input v-model="phone" class="uk-input  uk-text-center" type="tel" aria-label="Not clickable icon" placeholder="" autocomplete="tel">
        </div>
        </div>
 <div class="uk-margin ">
    <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}</label><br>
        <div class="uk-inline uk-width-expand">
        <span class="uk-form-icon " ></span>
        
        <select v-model="section" class="uk-select uk-text-center" aria-label="{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}">
                <option  v-for="sect in this.$store.getters.Sections" :value="sect.id" :key="sect.id">{{ sect[this.$store.getters.Lang] }}</option>                
        </select>
    </div>
    </div>
    <!--button class="uk-button uk-button-danger uk-width-expand">{{this.$store.getters.GetText.registration.cancel[this.$store.getters.Lang]}}</button-->
        </div>
        <!-- Second -->
        
        <div class="uk-width-1-2@m">
            <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.degree[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: bolt"></span>
                <select v-model="degree" class="uk-select uk-text-center " aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">            
                    <option class="uk-text-center" v-for="(degrees, index) in degree_list[this.$store.getters.Lang]" :key="index" :value="index">
                        {{degrees}}
                    </option>
                </select>
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.birt[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: calendar"></span>
                <input v-model="birthday" class="uk-input  uk-text-center" type="date" aria-label="Not clickable icon" placeholder="" name="bday" autocomplete="bday">
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.country[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon:  world"></span>
                <input v-model="country" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="country-name">
            </div>
            </div>        
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.city[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: home"></span>
                <input v-model="city" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="address-level1" name="city">
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.position[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: linkedin"></span>
            <input v-model="position" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="on" name="organization-title">
        </div>
        </div>
        <div class="uk-margin ">
        <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.personal[this.$store.getters.Lang]}}</label><br>
        <div class="uk-inline uk-width-expand">
        <span class="uk-form-icon " ></span>        
        <select v-model="acept" class="uk-select uk-text-center" aria-label="{{this.$store.getters.GetText.registration.personal[this.$store.getters.Lang]}}">
                <option>Agreement</option>
                <option>Disagreement</option>
        </select>
    </div>
    <div class="uk-margin ">
        <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}</label><br>
        <div class="uk-inline uk-width-expand">
        <span class="uk-form-icon " ></span>
       
        <select v-model="form" class="uk-select uk-text-center" aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">
                <option>Offline</option>
                <option>Online</option>
        </select>
    </div>
    <span v-if="!filled" class="uk-text-warning" v-html="message[this.$store.getters.Lang]"></span><br>
    <span v-if="!email_verify" class="uk-text-danger" v-html="message_email[this.$store.getters.Lang]"></span>
    <button class="uk-button uk-button-primary  uk-margin  uk-width-expand" :disabled="!filled" v-on:click="reg">{{this.$store.getters.GetText.navbar.reg[this.$store.getters.Lang]}}</button>
    <a class="uk-link-toggle uk-text-center" href="http://monomax.ru/data-agreement/" target="_blank">

    <span class="uk-link-heading">*{{this.$store.getters.GetText.registration.personal_label[this.$store.getters.Lang]}}</span>
    </a> 
    </div>
    
    
    </div>
      
        </div>

        
    </div>
    
    

    </div>
    </div>    
</template>

<script>
import axios from 'axios'

export default {
    name: "RegForm",
    data(){
        return{
            name :  null,
            email :  null,
            email_verify: true,
            password :  null,
            confirm :  null,
            degree :  null,
            country :  null,
            city :  null,
            work :  null,
            position :  null,
            birthday :  null,
            lang :  this.$store.getters.Lang,
            acept :  null,
            role :  1,
            section : null,
            form : null,
            phone : null,            
            filled : false,
            password_title:{
                En: 'Минимальная длина пароля 8 символов.<br>Пароль должен содержать буквы и цифры!',
                Ru: 'The minimum password length is 8 characters.<br>The password must contain letters and numbers!'
            },
            message: {
                En: '*Не все поля заполнены или не совпадают пароли!<br>Минимальная длина пароля 8 символов. ',
                Ru: '*Not all fields are filled or passwords confirm<br>do not match! The minimum password length is 8 characters'
            },
            message_email: {
                En: 'Указанный Email занят!',
                Ru: 'The specified email is busy!'
            },
            degree_list:{
                Ru:{1:'Student',2:'Master',3:'Postgraduate',4:'Candidate',5:'Doctor',6:'Corresponding Member',7:'Academician',8:'PHD'},
                En:{1:'Студент',2:'Магистрант',3:'Аспирант',4:'Кандидат наук',5:'Доктор наук',6:' Член-корреспондент РАН',7:'Академик РАН',8:'PHD'}
            }  


        }
    },
    beforeUpdate(){        
        if (this.email_verify && !!this.name && !!this.email && (this.password==this.confirm) && !!this.password && (this.password.length>7) && !!this.confirm && !!this.degree && !!this.country && !!this.city && !!this.work && !!this.position && !!this.birthday && !!this.lang && !!this.acept && !!this.role && !!this.section&& !!this.form&& !!this.phone && (this.acept=='Agreement')){
            this.filled=true
        } else {
            this.filled=false
        }
    },
    mounted(){
        if (!this.$store.getters.GetBlock.registration){
            this.$router.push({ path: 'home' })
        }
    },
    methods:{
        checkEmail(){
            var $this = this
            this.email_verify=true
            console.log('check mail')
            axios.post('/api/auth/check',
            {email: this.email}).then(
                res=>{
                    if (res.data.message!='ok'){
                        $this.email_verify=false
                    }
                }
            )
        },
        
        reg(){
            this.$store.commit('SET_Loaded',false)
            var $this= this
            var lang=this.lang==='En'?'Ru':'En'
            // accept is zero because later org teke new require for acepted participans on
            axios.post('/api/auth/reg',
            {
                name: this.name,
                email: this.email,
                password: this.password,
                password_confirmation: this.confirm,
                degree: this.degree,
                country: this.country,
                city: this.city,
                work: this.work,
                position: this.position,
                birthday: this.birthday,
                lang: lang,
                acept: 0,
                role: this.role,
                section: this.section,
                form: this.form,
                phone: this.phone
            }).then(
               
                result=>{
                    $this.$store.commit('SET_Loaded',true)
                    localStorage.setItem('access_token',result.data.access_token)
                    $this.$store.commit('SET_ACCESS_DIR',true)
                    this.$router.push({name:'personal'})
                    
                }
            ).catch(function(error) {
                    if (error.response) {
                        $this.$store.commit('SET_Loaded',true)
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        $this.$store.commit('SET_Errors', [error.response.status, true])

                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        //context.commit('SET_Errors', [error.response.status, true])
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        //context.commit('SET_Errors', [error.response.status, true])
                    }

                })
        }
    }
}
</script>
